import { Identifier, useGetList } from "react-admin";
import { filter, filterObject, filterValue } from "../../common/components/utils/fn";

export const getFilterValues = (filterValuesReceive: any, tab: string, teamId: Identifier) => {
    let filterValues = { ...filterValuesReceive };
    delete filterValues["members"];
    delete filterValues["_and"];
    if (tab === "myteam") {
        filterValues["members"] = filter("teamId", teamId);
    } else {
        filterValues["_and"] = filterValue([
            filterObject("_not.members.teamId._eq", teamId),
            filterObject("_not.role._eq", "admin")
        ]);
    }
    return filterValues;
}

const useTotal = (filterValuesReceive: any, value: string, teamId: Identifier): number => {
    const filterValues = getFilterValues(filterValuesReceive, value, teamId);
    const { total } = useGetList(
        'user',
        { perPage: 1, page: 1 },
        { field: 'id', order: 'ASC' },
        filterValues
    );
    return total;
};

export const useGetTotals = (filterValues: any, teamId: Identifier): { myteam: number, others: number } => {
    return {
        myteam: useTotal(filterValues, "myteam", teamId),
        others: useTotal(filterValues, "others", teamId)
    };
};